// =============================================================================
// contractualScope.ts — Patch R1.2 frontend client. Wires the (until now
// UI-orphaned) approve-from-cascade + read endpoints in
// workers/core-os/src/routes/contractual_scope.ts.
//
//   approveFromCascade — commits the project's latest cascade run's included
//     universe items into project_scope_items, keyed to the universe backbone
//     (linked_universe_item_id). Idempotent + ADDITIVE: a re-run inserts only
//     newly in-scope items; it never duplicates and never retires dropped ones
//     (removal is a separate gate, by design). The operator clicking IS the
//     approval (chassis #3/#7) — the cascade is the live draft, project scope
//     is the signed-off baseline that bids / commitments / the command board /
//     Ask-the-Builder read from.
//   get — the project's contractual scope rows (universe-keyed first), joined
//     to universe_items for the work-item text. Read-back for verification.
// =============================================================================

import { request } from './request'

export interface ContractualScopeApproveResult {
  ok: true
  project_id: string
  run_id: string
  universe_version: string
  approved: number // newly inserted this click
  already_present: number // skipped (already active)
  total_included: number
}

export interface ContractualScopeItemRow {
  id: string
  linked_universe_item_id: string | null
  scope_item_id: string | null
  phase: string | null
  assigned_trade: string | null
  status: string
  approved_at: string | null
  source_scope_run_id: string | null
  work_item: string | null
}

export interface ContractualScopeListResponse {
  ok: true
  count: number
  universe_keyed: number
  legacy_scope_item_keyed: number
  scope_items: ContractualScopeItemRow[]
}

export const contractualScopeApi = {
  approveFromCascade: (projectId: string) =>
    request<ContractualScopeApproveResult>(
      `/api/projects/${encodeURIComponent(projectId)}/contractual-scope/approve-from-cascade`,
      { method: 'POST', body: JSON.stringify({}) },
    ),

  get: (projectId: string) =>
    request<ContractualScopeListResponse>(
      `/api/projects/${encodeURIComponent(projectId)}/contractual-scope`,
    ),
}
